import React from 'react';

import Header from './Header'
import Navigation from './Navigation.jsx'
import Ribbon from './Ribbon.jsx'
import Footer from './Footer.jsx'
import ModalRoot from '../modal/ModalRoot';

class Layout extends React.Component {

  render() {

    let children = null;
    if (this.props.children) {
      children = React.cloneElement(this.props.children, {
        auth: this.props.route.auth //sends auth instance from route to children
      })
    }

    return (
      <div>
          <Header />
          <Navigation />

          <div id="main" role="main">
              <Ribbon />
              {children}
              <ModalRoot />
          </div>
          <Footer />
      </div>
    );
  }
}

export default Layout;



// WEBPACK FOOTER //
// ./src/pages/layout/Layout.js